const formData = {
  type: 'unsubscribe-catalogue',
  handle: /unsubscribe/,
  requestHandle: '/catalogue/unsubscribe',
  content: [
    {
      id: 'first_name',
      question: 'First Name',
      placeholder: 'Enter your first name*',
      type: 'text',
      required: true,
      answers: [''],
      hidden: false
    },
    {
      id: 'last_name',
      question: 'Last Name',
      placeholder: 'Enter your last name*',
      type: 'text',
      required: true,
      answers: [''],
      hidden: false
    },
    {
      id: 'address_line1',
      question: 'First line of your address',
      type: 'text',
      placeholder: 'Enter your first line of your address*',
      required: true,
      answers: [''],
      hidden: false
    },
    {
      id: 'postcode',
      question: 'Postcode',
      placeholder: 'Enter your postcode*',
      type: 'text',
      required: true,
      answers: [''],
      hidden: false
    },
    {
      id: 'unsubscribe_reason',
      question: 'Let us know why',
      type: 'textarea',
      required: false,
      placeholder: 'Let us know why — if you have a moment',
      answers: [''],
      hidden: false
    }
  ]
}

export default formData
